import React from 'react';
import { Link, useParams } from 'react-router-dom';
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Posts from '../data/data-guide.json';
import { companyInfo, socialLinks } from '../data/companyInfo';

function TourGuiderDetailsMain() {
    const { id } = useParams();
    const { ref, inView } = useInView({ triggerOnce: true }); // ✅ Hook moved to the top

    const guidePost = Posts.find(post => post.id === parseInt(id));

    if (!guidePost) {
        return <div>Post not found!</div>;
    }

    const counters = [
        { value: 12, suffix: "+", title: "Years Experience" },
        { value: 50, suffix: "+", title: "Tours Completed" },
        { value: 1500, suffix: "+", title: "Happy Clients" },
        { value: 8, suffix: "+", title: "Destinations" }
    ];

    return (
        <section className="space">
            <div className="container">
                <div className="team-details">
                    <div className="row gy-5 mb-3 mb-xl-5 pb-xl-4">
                        <div className="col-xl-4">
                            <div className="th-team team-grid">
                                <div className="team-img">
                                    <img src={`/assets/img/team/${guidePost.thumb}`} alt="Team" />
                                </div>
                                <div className="team-img2">
                                    <img src={`/assets/img/team/${guidePost.bannerImg}`} alt="Team" />
                                </div>
                                <div className="team-content">
                                    <div className="media-body">
                                        <h3 className="box-title">
                                            <Link to="#">{guidePost.title}</Link>
                                        </h3>
                                        <span className="team-desig">Tourist Guide</span>
                                        <div className="th-social">
                                            <Link target="_blank" rel="noopener noreferrer" to={socialLinks.facebook}>
                                                <i className="fab fa-facebook-f" />
                                            </Link>
                                            <Link target="_blank" rel="noopener noreferrer" to={socialLinks.instagram}>
                                                <i className="fab fa-instagram" />
                                            </Link>
                                            <Link target="_blank" rel="noopener noreferrer" to={socialLinks.tiktok}>
                                                <i className="fab fa-tiktok" />
                                            </Link>
                                            <Link target="_blank" rel="noopener noreferrer" to={socialLinks.whatsapp}>
                                                <i className="fab fa-whatsapp" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 ps-3 ps-xl-5 pe-xl-4">
                            <div className="team-about">
                                <h2 className="team-about_title">About Me</h2>
                                <p className="team-about_text mb-25">
                                    {guidePost.bio || `${guidePost.title} is a professional tour guide at Himolan Peak Adventures, dedicated to delivering safe, memorable, and culturally rich travel experiences across northern Pakistan.`}
                                </p>
                                <p className="team-about_text mb-25">
                                    Based in Skardu, our team is deeply rooted in the culture and geography of Gilgit-Baltistan. We take pride in our local knowledge, hospitality, and commitment to making every tour an extraordinary adventure.
                                </p>
                                <h5 className="box-title">{guidePost.experience || '5 Years of Experience'}</h5>
                                <p className="team-about_text mb-25">
                                    Speciality: {guidePost.speciality || 'Northern Pakistan Tours, Skardu, Hunza, Fairy Meadows'}
                                </p>
                                <div ref={ref} className="counter-box-wrap">
                                    {counters.map((counter, index) => (
                                        <div key={index} className="counter-box">
                                            <h2 className="counter-box_number">
                                                <CountUp
                                                    start={0}
                                                    end={inView ? counter.value : 0}
                                                    duration={2}
                                                />
                                                {counter.suffix}
                                            </h2>
                                            <span className="counter-box_title">{counter.title}</span>
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                    </div>
                    <h2 className="box-title mb-30">Contact With Me</h2>
                    <div className="row gy-4 justify-content-center">
                        <div className="col-xl-4 col-lg-6">
                            <div className="about-contact-grid style2">
                                <div className="about-contact-icon">
                                    <img src="/assets/img/icon/location-dot2.svg" alt="" />
                                </div>
                                <div className="about-contact-details">
                                    <h6 className="box-title">Our Address</h6>
                                    <p className="about-contact-details-text">
                                        2690 Hiltona Street Victoria
                                    </p>
                                    <p className="about-contact-details-text">
                                        {companyInfo.addressFull}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <div className="about-contact-grid">
                                <div className="about-contact-icon">
                                    <img src="/assets/img/icon/call.svg" alt="" />
                                </div>
                                <div className="about-contact-details">
                                    <h6 className="box-title">Phone Number</h6>
                                    <p className="about-contact-details-text">
                                        <Link to={`tel:${companyInfo.phoneDial}`}>{companyInfo.phoneDisplay}</Link>
                                    </p>
                                    <p className="about-contact-details-text">
                                        <Link to={`mailto:${companyInfo.email}`}>{companyInfo.email}</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-6">
                            <div className="about-contact-grid">
                                <div className="about-contact-icon">
                                    <img src="/assets/img/icon/mail.svg" alt="" />
                                </div>
                                <div className="about-contact-details">
                                    <h6 className="box-title">Email Address</h6>
                                    <p className="about-contact-details-text">
                                        <Link to={`mailto:${companyInfo.email}`}>{companyInfo.email}</Link>
                                    </p>
                                    <p className="about-contact-details-text">
                                        <Link to={`https://wa.me/${companyInfo.phoneDial}`} target="_blank" rel="noopener noreferrer">WhatsApp Inquiry</Link>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default TourGuiderDetailsMain
